import React, { useState, useEffect} from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import {season, year} from './Const'
import {CropList} from '../../api_servcies/getCropmaster'
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch } from 'react-redux';
import {setFilterOption} from '../../../redux/actions/mapaction'
import { bgColors } from '../../utils/bgColor';
import { Grid } from '@mui/material';

export default function Filtergroup(){
   const dispatch = useDispatch()
   const croplist = CropList('rabi')
   const [filter, setFilter] = useState({
    year: '2022',
    season: 'Rabi',
    crop: ""

   })
    const handleYearChange = (event) => {
      setFilter({
        ...filter,
        year:event.target.value
        });
    };
    const handleSeasonChange = (event) => {
      setFilter({
        ...filter,
        season:event.target.value
        });
    };
  
    const handleCropChange = (event) => {
      setFilter({...filter, crop: event.target.value});
    };

    const handleSubmit=(e)=> {
      e.preventDefault();
      dispatch(setFilterOption(filter))
    }

    const styles = {
      control: (base, state) => ({
          ...base,
          background: bgColors.grey_500,
          // match with the menu
          borderRadius: state.isFocused ? bgColors.grey_700 : 10,
          // Overwrittes the different states of border
          borderColor: state.isFocused ? bgColors.grey_700 : bgColors.blue_500,
          // Removes weird border around container
          boxShadow: state.isFocused ? null : null,
          "&:hover": {
            // Overwrittes the different states of border
            borderColor: state.isFocused ? bgColors.grey_700 : bgColors.blue_500,
            borderRadius: state.isFocused ? bgColors.grey_700 : 10,
          },
          "&:focussed": {
              // Overwrittes the different states of border
              borderColor: state.isFocused ? bgColors.grey_700 : bgColors.blue_500,
              borderRadius: state.isFocused ? bgColors.grey_400 : 10,
            }
        }),
      valueContainer: base => ({
        ...base,
        paddingLeft: 24,
      //   backgroundColor: bgColors.grey_900,
        color:bgColors.grey_400
      }),
      menuList: styles => ({
          ...styles,
          background: bgColors.grey_400,
          color:bgColors.grey_800,
          borderRadius:5
         
      }),
      option: (styles, {isFocused, isSelected}) => ({
          ...styles,
          background: isFocused
              ? bgColors.blue_500
              : isSelected
                  ? bgColors.grey_400
                  : undefined,
          zIndex: 10
      }),
  
    };


  return (
    <FormControl>
      <FormLabel id="season-group-label">Season </FormLabel>
      <Grid container spacing={1} display='flex' padding={2} direction={"column"}>
      <RadioGroup
        row
        aria-labelledby="season-group-label"
        name="season-group"
        value = {filter.season}
        onChange= {handleSeasonChange}
      >
        {season.map((item,index)=> 
            <FormControlLabel value={item} control={<Radio />} label={item}
            key = {`${item}_${index}_radio`}
            />
            )
        }
      </RadioGroup>
      </Grid>
      <Divider/>
      
      <FormLabel id="year-group-label">Year </FormLabel>
      <Grid container spacing={1} display='flex' padding={2} direction={"column"}>
      <RadioGroup
        row
        aria-labelledby="year-group-label"
        name="year-group"
        value = {filter.year}
        onChange= {handleYearChange}
        styles={styles}
      >
        {year().map((item,index)=> 
            <FormControlLabel value={item} control={<Radio />} label={item}
            key = {`${item}_${index}_year`}
            />
            )
        }
      </RadioGroup>
      </Grid>
      <Divider />
      <FormLabel id="selected crop"> Select Crop </FormLabel>
        <Select
          fullWidth
          size='small'
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={filter.crop}
          label="Crop"
          onChange={handleCropChange}
        >
          {croplist.options.map((item,index) => 
              <MenuItem key = {`${index}_menu_item`} value={item.name}>{item.name}</MenuItem>
          )
          }
        </Select>

        <Button onClick={handleSubmit}>
          Save
        </Button>
    </FormControl>
  );
}
